(function () {
  'use strict';

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var grids = document.querySelectorAll('.quiz-hub__grid');
    if (!grids.length) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var cards = entry.target.querySelectorAll('.quiz-hub__card');
          cards.forEach(function (card, index) {
            card.style.transitionDelay = index * 80 + 'ms';
            card.classList.add('quiz-hub__card--visible');
          });
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15 }
    );

    grids.forEach(function (grid) {
      grid.querySelectorAll('.quiz-hub__card').forEach(function (card) {
        card.classList.add('quiz-hub__card--reveal');
      });
      observer.observe(grid);
    });
  }

  /* ---------- Quiz modal ---------- */
  var lastFocused = null;
  var savedScrollY = 0;
  var QUIZ_COMPLETE_PREFIX = 'quiz-hub-complete-';
  var UPSELL_SHOWN_PREFIX = 'quiz-hub-upsell-shown-';
  var completedQuizModals = {};

  function isQuizResultsPage(body) {
    if (!body) return false;
    return !!body.querySelector(
      '.oct-quiz-wrapper--result-page, .oct-quiz-result-item'
    );
  }

  function getCardForModal(modalId) {
    return document.querySelector('[data-quiz-card-for="' + modalId + '"]');
  }

  function isQuizCompleted(modalId) {
    return completedQuizModals[modalId] === true;
  }

  function setCardCompleted(card, completed) {
    if (!card) return;
    var start = card.querySelector('.quiz-hub__card-start');
    var completedEl = card.querySelector('.quiz-hub__card-completed');
    var modalId = card.getAttribute('data-quiz-card-for');
    // Hub cards are themselves the click trigger; standalone launchers keep
    // the trigger on a real <button> inside .quiz-hub__card-start.
    var cardIsTrigger = card.classList.contains('quiz-hub__card');

    if (completed) {
      card.classList.add('quiz-hub__card--completed');
      if (cardIsTrigger) {
        card.removeAttribute('role');
        card.removeAttribute('tabindex');
        card.removeAttribute('aria-haspopup');
        card.removeAttribute('data-quiz-open');
      }
      if (start) start.hidden = true;
      if (completedEl) completedEl.hidden = false;
    } else {
      card.classList.remove('quiz-hub__card--completed');
      if (cardIsTrigger) {
        card.setAttribute('role', 'button');
        card.setAttribute('tabindex', '0');
        card.setAttribute('aria-haspopup', 'dialog');
        if (modalId) card.setAttribute('data-quiz-open', modalId);
      }
      if (start) start.hidden = false;
      if (completedEl) completedEl.hidden = true;
    }
  }

  function markQuizCompleted(modal) {
    if (!modal || !modal.id || modal._quizCompleteMarked) return;
    modal._quizCompleteMarked = true;
    completedQuizModals[modal.id] = true;
    setCardCompleted(getCardForModal(modal.id), true);
  }

  function clearQuizCompleted(modalId) {
    delete completedQuizModals[modalId];
    setCardCompleted(getCardForModal(modalId), false);
  }

  function checkForQuizComplete(modal, body) {
    if (!modal || modal._quizCompleteMarked) return;
    if (isQuizResultsPage(body)) {
      markQuizCompleted(modal);
    }
  }

  function initCompletedCards() {
    document.querySelectorAll('[data-quiz-card-for]').forEach(function (card) {
      var modalId = card.getAttribute('data-quiz-card-for');
      try {
        sessionStorage.removeItem(QUIZ_COMPLETE_PREFIX + modalId);
        localStorage.removeItem(QUIZ_COMPLETE_PREFIX + modalId);
      } catch (e) {}
    });
  }

  function resetQuiz(modal) {
    if (!modal) return;
    var body = modal.querySelector('[data-quiz-body]');

    if (modal._quizMutationObserver) {
      modal._quizMutationObserver.disconnect();
      modal._quizMutationObserver = null;
    }

    resetPostQuizInModal(modal);

    if (body) {
      body.innerHTML = '';
      body.scrollTop = 0;
    }

    delete modal.dataset.quizLoaded;
    delete modal.dataset.quizResultCartBound;
    modal._quizScrollBound = false;
    modal._quizAddedToCart = false;
    modal._postQuizShown = false;
    modal._quizCompleteMarked = false;

    clearQuizCompleted(modal.id);
  }

  // Freeze the page behind the modal so Octane's auto-scroll between quiz
  // steps can't move the background.
  function lockBodyScroll() {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = -savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.documentElement.classList.add('quiz-hub-modal-open');
  }

  function unlockBodyScroll() {
    document.documentElement.classList.remove('quiz-hub-modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);
  }

  // Re-create <script> tags so they execute after being cloned from a <template>.
  function runScripts(container) {
    var scripts = container.querySelectorAll('script');
    scripts.forEach(function (oldScript) {
      var newScript = document.createElement('script');
      for (var i = 0; i < oldScript.attributes.length; i++) {
        var attr = oldScript.attributes[i];
        newScript.setAttribute(attr.name, attr.value);
      }
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function findNativeBack(body) {
    if (!body) return null;
    var btns = body.querySelectorAll('.oct-quiz-btn');
    for (var i = 0; i < btns.length; i++) {
      var txt = (btns[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (txt === 'skip' || (txt.indexOf('skip') !== -1 && txt.length <= 12)) continue;
      if (txt === 'back' || (txt.indexOf('back') !== -1 && txt.length <= 12)) {
        return btns[i];
      }
    }
    return null;
  }

  function findNativeSkip(body) {
    if (!body) return null;
    var skipWrapper = body.querySelector('.oct-quiz-btn-wrapper-skip');
    if (skipWrapper) {
      return skipWrapper.querySelector('.oct-quiz-btn') ||
        skipWrapper.querySelector('button, a[role="button"], a');
    }
    var btns = body.querySelectorAll('.oct-quiz-btn');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.classList.contains('quiz-hub__native-back')) continue;
      if (btn.classList.contains('oct-quiz-btn--primary')) continue;
      var txt = (btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (txt === 'skip' || (txt.indexOf('skip') !== -1 && txt.length <= 12)) {
        return btn;
      }
    }
    return null;
  }

  function isTimerExplainerStep(body) {
    if (!body) return false;
    var explainer = body.querySelector('.oct-quiz-wrapper--explainer');
    if (!explainer) return false;
    // Loading transition screens auto-advance via timer — no primary Continue button.
    return !explainer.querySelector('.oct-quiz-btn--primary');
  }

  function syncBackButton(modal) {
    var body = modal.querySelector('[data-quiz-body]');
    var ourBack = modal.querySelector('[data-quiz-back]');
    if (!body || !ourBack) return;

    var nativeBack = findNativeBack(body);
    if (nativeBack) {
      nativeBack.classList.add('quiz-hub__native-back');
    }

    if (isTimerExplainerStep(body)) {
      ourBack.hidden = true;
      return;
    }

    if (nativeBack) {
      ourBack.hidden = false;
    } else {
      ourBack.hidden = true;
    }
  }

  function syncSkipButton(modal) {
    var body = modal.querySelector('[data-quiz-body]');
    var ourSkip = modal.querySelector('[data-quiz-skip]');
    if (!body || !ourSkip) return;

    body.querySelectorAll('.quiz-hub__native-skip-wrapper').forEach(function (wrapper) {
      wrapper.classList.remove('quiz-hub__native-skip-wrapper');
    });

    var nativeSkip = findNativeSkip(body);
    if (nativeSkip) {
      nativeSkip.classList.add('quiz-hub__native-skip');
      var skipWrapper = nativeSkip.closest('.oct-quiz-btn-wrapper');
      if (skipWrapper && !skipWrapper.querySelector('.oct-quiz-btn--primary')) {
        skipWrapper.classList.add('quiz-hub__native-skip-wrapper');
      }
      var label = (nativeSkip.textContent || '').replace(/\s+/g, ' ').trim();
      var ourLabel = ourSkip.querySelector('.quiz-hub__modal-skip-label');
      if (ourLabel) ourLabel.textContent = label || 'Skip';
      ourSkip.hidden = false;
    } else {
      ourSkip.hidden = true;
    }
  }

  // Octane adds a square border on the inner select — strip it, keep native arrow.
  function styleVariantDropdowns(container) {
    if (!container) return;
    var masks = container.querySelectorAll('.oct-quiz-result-item__dropdown-mask');
    masks.forEach(function (mask) {
      mask.style.setProperty('overflow', 'hidden', 'important');
      mask.style.setProperty('border-radius', '10px', 'important');

      var select = mask.querySelector('select');
      if (!select) return;

      [
        ['border', '0 none transparent'],
        ['border-width', '0'],
        ['outline', 'none'],
        ['box-shadow', 'none'],
        ['margin', '0'],
        ['border-radius', '10px'],
        ['min-height', '44px'],
        ['line-height', '1.45'],
        ['padding', '12px 36px 13px 14px']
      ].forEach(function (pair) {
        select.style.setProperty(pair[0], pair[1], 'important');
      });
    });
  }

  function syncFooterButtons(modal) {
    syncBackButton(modal);
    syncSkipButton(modal);
    syncResultsPromo(modal);
  }

  function syncResultsPromo(modal) {
    var promo = modal.querySelector('[data-quiz-results-promo]');
    if (!promo) {
      modal.classList.remove('quiz-hub__modal--results-promo');
      return;
    }
    var body = modal.querySelector('[data-quiz-body]');
    var show = isQuizResultsPage(body) && !modal.classList.contains('quiz-hub__modal--post-quiz');
    promo.hidden = !show;
    modal.classList.toggle('quiz-hub__modal--results-promo', show);
  }

  function initResultsPromoCopy(promo) {
    if (!promo || promo.dataset.quizPromoCopyBound === 'true') return;
    var btn = promo.querySelector('[data-quiz-promo-copy]');
    var codeEl = promo.querySelector('[data-quiz-promo-code]');
    var label = promo.querySelector('[data-quiz-promo-copy-label]');
    if (!btn || !codeEl) return;

    var defaultLabel = label ? label.textContent.trim() : 'Copy';
    var copiedLabel = promo.getAttribute('data-quiz-promo-copied-label') || 'Copied!';

    btn.addEventListener('click', function () {
      var code = (codeEl.textContent || '').trim();
      if (!code) return;

      function showCopied() {
        if (label) label.textContent = copiedLabel;
        btn.classList.add('is-copied');
        window.setTimeout(function () {
          if (label) label.textContent = defaultLabel;
          btn.classList.remove('is-copied');
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(showCopied).catch(function () {
          fallbackCopy(code, showCopied);
        });
      } else {
        fallbackCopy(code, showCopied);
      }
    });

    promo.dataset.quizPromoCopyBound = 'true';
  }

  function fallbackCopy(text, onSuccess) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      if (document.execCommand('copy') && onSuccess) onSuccess();
    } catch (e) {}
    document.body.removeChild(textarea);
  }

  function initResultsPromos() {
    document.querySelectorAll('[data-quiz-results-promo]').forEach(function (promo) {
      initResultsPromoCopy(promo);
    });
  }

  function getQuizHubSection(fromEl) {
    return fromEl && fromEl.closest ? fromEl.closest('.quiz-hub') : null;
  }

  function getSectionUpsellKey(section) {
    if (!section) return UPSELL_SHOWN_PREFIX + 'default';
    var id = section.getAttribute('data-quiz-section-id');
    return UPSELL_SHOWN_PREFIX + (id || 'default');
  }

  function wasUpsellShownThisVisit(section) {
    try {
      return sessionStorage.getItem(getSectionUpsellKey(section)) === '1';
    } catch (e) {
      return false;
    }
  }

  function markUpsellShownThisVisit(section) {
    try {
      sessionStorage.setItem(getSectionUpsellKey(section), '1');
    } catch (e) {}
  }

  function markQuizCartAdd(modal) {
    if (modal) modal._quizAddedToCart = true;
  }

  function hasPostQuizUpsell(section) {
    if (!section) return false;
    var wrap = section.querySelector('[data-quiz-post-upsell-wrap]');
    return !!(wrap && wrap.querySelector('[data-quiz-post-upsell]'));
  }

  function getPostQuizPanel(section) {
    if (!section) return null;
    return section.querySelector('[data-quiz-post-upsell]');
  }

  function restoreQuizFooterControls(modal) {
    if (!modal) return;
    var start = modal.querySelector('.quiz-hub__modal-footer-start');
    if (start) start.hidden = false;
    syncFooterButtons(modal);
  }

  function mountPostQuizFooterActions(modal, panel) {
    var footer = modal.querySelector('[data-quiz-footer]');
    var actions = panel.querySelector('[data-quiz-post-upsell-footer-actions]');
    if (!footer || !actions) return;

    var start = footer.querySelector('.quiz-hub__modal-footer-start');
    if (start) start.hidden = true;

    footer.appendChild(actions);
    actions.hidden = false;
  }

  function unmountPostQuizFooterActions(modal, panel) {
    var section = modal && getQuizHubSection(modal);
    if (!panel && section) panel = getPostQuizPanel(section);

    var actions = (modal && modal.querySelector('[data-quiz-post-upsell-footer-actions]')) ||
      (panel && panel.querySelector('[data-quiz-post-upsell-footer-actions]'));

    if (actions) {
      actions.hidden = true;
      if (panel && actions.parentElement !== panel) {
        panel.appendChild(actions);
      }
    }

    restoreQuizFooterControls(modal);
  }

  function resetPostQuizInModal(modal) {
    if (!modal) return;
    var section = getQuizHubSection(modal);
    var wrap = section && section.querySelector('[data-quiz-post-upsell-wrap]');
    var panel = getPostQuizPanel(section);
    var stage = modal.querySelector('[data-quiz-post-upsell-stage]');

    unmountPostQuizFooterActions(modal, panel);
    modal.classList.remove('quiz-hub__modal--post-quiz');
    syncResultsPromo(modal);
    if (stage) stage.hidden = true;

    if (panel && wrap && panel.parentElement !== wrap) {
      panel.hidden = true;
      panel.classList.remove('is-visible');
      wrap.appendChild(panel);
    }
    if (wrap) wrap.hidden = true;
  }

  function showPostQuizInModal(modal) {
    var section = getQuizHubSection(modal);
    var wrap = section && section.querySelector('[data-quiz-post-upsell-wrap]');
    var panel = getPostQuizPanel(section);
    var stage = modal.querySelector('[data-quiz-post-upsell-stage]');
    if (!panel || !stage || !wrap) return;

    stage.appendChild(panel);
    wrap.hidden = true;
    panel.hidden = false;
    panel.classList.add('is-visible');
    stage.hidden = false;
    modal.classList.add('quiz-hub__modal--post-quiz');
    mountPostQuizFooterActions(modal, panel);
    syncResultsPromo(modal);

    var hint = modal.querySelector('[data-quiz-scroll-hint]');
    if (hint) hint.classList.remove('is-visible');

    window.requestAnimationFrame(function () {
      stage.scrollTop = 0;
      var atc = modal.querySelector('[data-quiz-upsell-atc]:not([disabled])');
      var closeBtn = modal.querySelector('.quiz-hub__modal-close');
      if (atc) {
        atc.focus();
      } else if (closeBtn) {
        closeBtn.focus();
      }
    });
  }

  function requestCloseModal(modal) {
    if (!modal || modal.classList.contains('quiz-hub__modal--hidden')) return;

    if (modal.classList.contains('quiz-hub__modal--post-quiz')) {
      closeModal(modal);
      return;
    }

    var section = getQuizHubSection(modal);
    if (
      modal._quizAddedToCart &&
      hasPostQuizUpsell(section) &&
      !modal._postQuizShown &&
      !wasUpsellShownThisVisit(section)
    ) {
      modal._postQuizShown = true;
      markUpsellShownThisVisit(section);
      showPostQuizInModal(modal);
      return;
    }

    closeModal(modal);
  }

  function isQuizTeaAddToCartClick(target, body) {
    if (!target || !body) return false;
    if (target.closest('[data-quiz-post-upsell], [data-quiz-footer]')) {
      return false;
    }

    var btn = target.closest(
      '.oct-quiz-result-actions-wrapper .oct-quiz-btn, ' +
      '.oct-quiz-result-actions-wrapper button, ' +
      '.oct-quiz-products__item .oct-quiz-btn, ' +
      '.oct-quiz-result-item .oct-quiz-btn'
    );
    if (!btn || !body.contains(btn)) return false;

    var txt = (btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
    if (txt === 'back' || (txt.indexOf('back') !== -1 && txt.length <= 12)) return false;
    if (txt === 'skip' || (txt.indexOf('skip') !== -1 && txt.length <= 12)) return false;

    return true;
  }

  function initQuizResultCartWatch(modal) {
    if (modal.dataset.quizResultCartBound === 'true') return;
    var body = modal.querySelector('[data-quiz-body]');
    if (!body) return;

    body.addEventListener('click', function (e) {
      if (isQuizTeaAddToCartClick(e.target, body)) {
        markQuizCartAdd(modal);
      }
    });

    modal.dataset.quizResultCartBound = 'true';
  }

  function formatUpsellMoney(cents) {
    if (typeof formatMoney === 'function' && typeof theme !== 'undefined' && theme.settings) {
      return formatMoney(cents, theme.settings.money_with_currency_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getUpsellSelectedOption(select) {
    if (!select) return null;
    if (select.tagName === 'SELECT') {
      return select.options[select.selectedIndex];
    }
    return null;
  }

  function updateUpsellVariantState(panel) {
    var select = panel.querySelector('[data-quiz-upsell-variant]');
    var atc = panel.querySelector('[data-quiz-upsell-atc]');
    var atcLabel = panel.querySelector('[data-quiz-upsell-atc-label]');
    if (!select) return;

    if (select.tagName === 'INPUT') {
      panel.dataset.quizUpsellVariantId = select.value;
      return;
    }

    var priceWrap = panel.querySelector('[data-quiz-upsell-price]');
    var priceCurrent = panel.querySelector('[data-quiz-upsell-price-current]');
    var compareEl = panel.querySelector('.quiz-hub__post-quiz-price-compare');

    var variantId = select.value;
    var option = getUpsellSelectedOption(select);
    var price = option ? parseInt(option.getAttribute('data-price'), 10) : 0;
    var compareAt = option ? parseInt(option.getAttribute('data-compare-at'), 10) : 0;
    var available = option ? option.getAttribute('data-available') === 'true' : true;

    if (priceCurrent) {
      priceCurrent.textContent = formatUpsellMoney(price);
    }
    if (priceWrap) {
      if (compareEl) {
        if (compareAt > price) {
          compareEl.textContent = formatUpsellMoney(compareAt);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      } else if (compareAt > price) {
        var compareNode = document.createElement('span');
        compareNode.className = 'quiz-hub__post-quiz-price-compare';
        compareNode.textContent = formatUpsellMoney(compareAt);
        priceWrap.insertBefore(compareNode, priceCurrent);
      }
    }

    if (atc) {
      atc.disabled = !available;
      if (atcLabel) {
        atcLabel.textContent = available
          ? (panel.getAttribute('data-quiz-upsell-atc-label') || 'Add to cart')
          : (typeof theme !== 'undefined' && theme.variantStrings ? theme.variantStrings.soldOut : 'Sold out');
      }
    }

    panel.dataset.quizUpsellVariantId = variantId;
  }

  function stylePostQuizVariantSelect(panel) {
    var mask = panel.querySelector('.quiz-hub__post-quiz-variant-mask');
    var select = panel.querySelector('[data-quiz-upsell-variant]');
    if (!mask || !select || select.tagName !== 'SELECT') return;

    mask.style.setProperty('overflow', 'hidden', 'important');
    mask.style.setProperty('border-radius', '10px', 'important');
    [
      ['border', '0 none transparent'],
      ['border-width', '0'],
      ['outline', 'none'],
      ['box-shadow', 'none'],
      ['margin', '0'],
      ['border-radius', '10px'],
      ['min-height', '44px'],
      ['line-height', '1.45'],
      ['padding', '12px 40px 13px 14px'],
      ['appearance', 'none'],
      ['-webkit-appearance', 'none']
    ].forEach(function (pair) {
      select.style.setProperty(pair[0], pair[1], 'important');
    });
  }

  function getCartSectionsToRender() {
    return [
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ];
  }

  function getCartAddUrl() {
    return (typeof theme !== 'undefined' && theme.routes && theme.routes.cart_add_url)
      ? theme.routes.cart_add_url
      : '/cart/add.js';
  }

  function getSectionInnerHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : '';
  }

  function renderCartSections(parsedState) {
    if (!parsedState) return;
    var sections = parsedState.sections || parsedState;

    getCartSectionsToRender().forEach(function (section) {
      var root = document.getElementById(section.id);
      var html = sections[section.section];
      if (!root || !html) return;
      var elementToReplace = root.querySelector(section.selector) || root;
      elementToReplace.innerHTML = getSectionInnerHTML(html, section.selector);
    });

    if (typeof CartDrawer !== 'undefined') {
      if (CartDrawer.instance) {
        CartDrawer.instance.removeProductEvent();
        CartDrawer.instance.notesToggle();
        CartDrawer.instance.termsCheckbox();
      } else {
        new CartDrawer();
      }
    }
  }

  function refreshCartSectionsFromFetch() {
    var sections = getCartSectionsToRender().map(function (section) {
      return section.section;
    }).join(',');

    return fetch(window.location.pathname + '?sections=' + sections + '&_cb=' + Date.now(), {
      method: 'GET',
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) { return response.text(); })
      .then(function (text) {
        renderCartSections(JSON.parse(text));
      });
  }

  function notifyCartAddSuccess(responseData, openDrawer) {
    if (openDrawer && typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('cart:item-added', {
        product: responseData && responseData.hasOwnProperty('items')
          ? responseData.items[0]
          : responseData
      });
    }

    if (
      openDrawer &&
      typeof theme !== 'undefined' &&
      theme.settings &&
      theme.settings.cart_drawer
    ) {
      openCartDrawer();
    }
  }

  function syncCartUiAfterAdd(responseData, openDrawer) {
    if (openDrawer === undefined) openDrawer = true;

    if (responseData && responseData.sections) {
      renderCartSections(responseData);
      notifyCartAddSuccess(responseData, openDrawer);
      return Promise.resolve();
    }

    return refreshCartSectionsFromFetch().then(function () {
      notifyCartAddSuccess(responseData || {}, openDrawer);
    });
  }

  function getActiveQuizModal() {
    var modal = getOpenModal();
    if (!modal || !modal.hasAttribute('data-quiz-modal')) return null;
    if (modal.classList.contains('quiz-hub__modal--post-quiz')) return null;
    return modal;
  }

  function shouldSyncQuizCartAdd() {
    var modal = getActiveQuizModal();
    if (!modal) return false;
    return isQuizResultsPage(modal.querySelector('[data-quiz-body]'));
  }

  var quizResultCartSyncTimer = null;

  function scheduleQuizResultCartSync(responseData) {
    if (quizResultCartSyncTimer) window.clearTimeout(quizResultCartSyncTimer);
    quizResultCartSyncTimer = window.setTimeout(function () {
      quizResultCartSyncTimer = null;
      if (!shouldSyncQuizCartAdd()) return;
      syncCartUiAfterAdd(responseData, false).catch(function () {});
    }, 350);
  }

  function installQuizCartOctaneSync() {
    if (window._quizHubOctaneCartSyncInstalled) return;
    window._quizHubOctaneCartSyncInstalled = true;

    document.addEventListener('octane.quiz.addToCart', function () {
      if (!shouldSyncQuizCartAdd()) return;
      var modal = getActiveQuizModal();
      if (modal) markQuizCartAdd(modal);
      scheduleQuizResultCartSync(null);
    }, false);
  }

  function openCartDrawer() {
    var cartDrawer = document.getElementById('Cart-Drawer');
    if (!cartDrawer) return;
    document.body.classList.add('open-cc');
    cartDrawer.classList.add('active');
    if (typeof dispatchCustomEvent === 'function') {
      dispatchCustomEvent('cart-drawer:open');
    }
  }

  function initPostQuizUpsellPanel(panel) {
    if (!panel || panel.dataset.quizUpsellBound === 'true') return;

    var atc = panel.querySelector('[data-quiz-upsell-atc]');
    var atcLabel = panel.querySelector('[data-quiz-upsell-atc-label]');
    if (atc && atcLabel) {
      panel.setAttribute('data-quiz-upsell-atc-label', atcLabel.textContent.trim());
    }

    var select = panel.querySelector('[data-quiz-upsell-variant]');
    if (select && select.tagName === 'SELECT') {
      select.addEventListener('change', function () {
        updateUpsellVariantState(panel);
      });
    }

    if (atc) {
      atc.addEventListener('click', function () {
        var variantInput = panel.querySelector('[data-quiz-upsell-variant]');
        var variantId = variantInput ? variantInput.value : null;
        if (!variantId || atc.disabled) return;

        atc.disabled = true;
        atc.classList.add('is-loading');
        var labelEl = panel.querySelector('[data-quiz-upsell-atc-label]');

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        formData.append(
          'sections',
          getCartSectionsToRender().map(function (section) { return section.section; }).join(',')
        );
        formData.append('sections_url', window.location.pathname);

        var cartUrl = getCartAddUrl();

        fetch(cartUrl, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/javascript'
          },
          body: formData
        })
          .then(function (response) { return response.json(); })
          .then(function (response) {
            if (response.status) {
              throw new Error(response.description || 'Add to cart failed');
            }

            syncCartUiAfterAdd(response).then(function () {
              var hostModal = panel.closest('[data-quiz-modal]');
              if (hostModal) closeModal(hostModal);
            });
          })
          .catch(function () {
            if (labelEl) labelEl.textContent = 'Error';
          })
          .finally(function () {
            atc.classList.remove('is-loading');
            if (!panel.closest('[data-quiz-modal]')) return;
            window.setTimeout(function () {
              updateUpsellVariantState(panel);
            }, 1800);
          });
      });
    }

    stylePostQuizVariantSelect(panel);
    updateUpsellVariantState(panel);
    panel.dataset.quizUpsellBound = 'true';
  }

  function initPostQuizUpsellSections() {
    document.querySelectorAll('[data-quiz-post-upsell-wrap]').forEach(function (wrap) {
      var section = wrap.closest('.quiz-hub');
      var panel = wrap.querySelector('[data-quiz-post-upsell]');
      if (!panel) return;

      initPostQuizUpsellPanel(panel);

      var dismiss = panel.querySelector('[data-quiz-post-upsell-dismiss]');
      if (dismiss && dismiss.dataset.quizUpsellDismissBound !== 'true') {
        dismiss.addEventListener('click', function () {
          var hostModal = panel.closest('[data-quiz-modal]');
          if (hostModal) {
            closeModal(hostModal);
          }
        });
        dismiss.dataset.quizUpsellDismissBound = 'true';
      }
    });
  }

  var STEP_SELECTORS =
    '.oct-quiz-content, .oct-quiz-multiple-choice-wrapper, .oct-quiz-picture-choice-wrapper';

  // Did a mutation add a new quiz step (i.e. the quiz navigated pages)?
  function isStepChange(mutations) {
    return mutations.some(function (m) {
      for (var i = 0; i < m.addedNodes.length; i++) {
        var n = m.addedNodes[i];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches(STEP_SELECTORS)) ||
            (n.querySelector && n.querySelector(STEP_SELECTORS))) {
          return true;
        }
      }
      return false;
    });
  }

  function scrollModalToTop(modal) {
    var body = modal.querySelector('[data-quiz-body]');
    if (!body) return;
    body.scrollTop = 0;
    if (modal._quizScrollTimer) window.clearTimeout(modal._quizScrollTimer);
    modal._quizScrollTimer = window.setTimeout(function () {
      body.scrollTop = 0;
      updateScrollHint(modal);
    }, 50);
  }

  // Show the bottom fade only when there's more content to scroll to.
  function updateScrollHint(modal) {
    var body = modal.querySelector('[data-quiz-body]');
    var hint = modal.querySelector('[data-quiz-scroll-hint]');
    if (!body || !hint) return;
    var overflow = body.scrollHeight - body.clientHeight;
    var canScroll = overflow > 8;
    var atBottom = body.scrollTop + body.clientHeight >= body.scrollHeight - 8;
    hint.classList.toggle('is-visible', canScroll && !atBottom);
  }

  // Watch only for quiz re-renders so we can sync our Back button.
  // We intentionally do NOT modify Octane's layout/size from JS — CSS handles
  // sizing — otherwise Octane reports "Quiz container element lost".
  function watchQuizRender(modal) {
    var body = modal.querySelector('[data-quiz-body]');
    if (!body) return;

    syncFooterButtons(modal);
    updateScrollHint(modal);
    styleVariantDropdowns(body);
    initQuizResultCartWatch(modal);

    if (!modal._quizScrollBound) {
      body.addEventListener('scroll', function () {
        updateScrollHint(modal);
      }, { passive: true });
      modal._quizScrollBound = true;
    }

    if (modal._quizMutationObserver) {
      modal._quizMutationObserver.disconnect();
    }
    var mutationObserver = new MutationObserver(function (mutations) {
      syncFooterButtons(modal);
      styleVariantDropdowns(body);
      checkForQuizComplete(modal, body);
      if (isStepChange(mutations)) {
        scrollModalToTop(modal);
      }
      updateScrollHint(modal);
    });
    mutationObserver.observe(body, { childList: true, subtree: true });
    modal._quizMutationObserver = mutationObserver;

    /* Octane renders asynchronously — check briefly after open */
    var attempts = 0;
    var retry = window.setInterval(function () {
      syncFooterButtons(modal);
      updateScrollHint(modal);
      styleVariantDropdowns(body);
      checkForQuizComplete(modal, body);
      attempts += 1;
      if (body.querySelector('.octane-ai-quiz-rendered') || attempts >= 20) {
        window.clearInterval(retry);
      }
    }, 250);
  }

  function loadQuiz(modal) {
    if (modal.dataset.quizLoaded === 'true') return;
    var body = modal.querySelector('[data-quiz-body]');
    var template = document.querySelector('template[data-quiz-embed-for="' + modal.id + '"]');
    if (!body || !template) return;

    body.appendChild(template.content.cloneNode(true));
    runScripts(body);
    modal.dataset.quizLoaded = 'true';
  }

  // FLIP morph: start the dialog transformed down to the launcher panel's
  // rect, then transition to its natural position so the panel appears to
  // grow into the modal.
  function morphModalFromPanel(modal, panel) {
    var dialog = modal.querySelector('.quiz-hub__modal-dialog');
    var backdrop = modal.querySelector('.quiz-hub__modal-backdrop');
    if (!dialog) return;

    var pRect = panel.getBoundingClientRect();
    var dRect = dialog.getBoundingClientRect();
    if (!pRect.width || !pRect.height || !dRect.width || !dRect.height) return;

    var dx = pRect.left - dRect.left;
    var dy = pRect.top - dRect.top;
    var sx = pRect.width / dRect.width;
    var sy = pRect.height / dRect.height;

    modal.classList.add('quiz-hub__modal--morphing');

    // Inline so it survives cleanup: re-enabling the stylesheet's slide-up
    // animation after the morph would replay it and cause a flash. Cleared
    // in closeModal.
    dialog.style.animation = 'none';

    dialog.style.transition = 'none';
    dialog.style.transformOrigin = 'top left';
    dialog.style.transform =
      'translate(' + dx + 'px, ' + dy + 'px) scale(' + sx + ', ' + sy + ')';
    dialog.style.borderRadius = '28px';
    dialog.style.opacity = '0.2';
    if (backdrop) {
      backdrop.style.transition = 'none';
      backdrop.style.opacity = '0';
    }

    function cleanup() {
      modal.classList.remove('quiz-hub__modal--morphing');
      dialog.style.transition = '';
      dialog.style.transformOrigin = '';
      dialog.style.transform = '';
      dialog.style.borderRadius = '';
      dialog.style.opacity = '';
      if (backdrop) {
        backdrop.style.transition = '';
        backdrop.style.opacity = '';
      }
    }

    // Double rAF so the squeezed start state paints before transitioning.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var ease = 'cubic-bezier(0.22, 1, 0.36, 1)';
        dialog.style.transition =
          'transform 0.45s ' + ease + ', border-radius 0.45s ' + ease + ', opacity 0.3s ease';
        dialog.style.transform = '';
        dialog.style.borderRadius = '';
        dialog.style.opacity = '';
        if (backdrop) {
          backdrop.style.transition = 'opacity 0.45s ease';
          backdrop.style.opacity = '';
        }
        window.setTimeout(cleanup, 500);
      });
    });
  }

  function openModal(modal, trigger) {
    if (!modal) return;
    lastFocused = trigger || document.activeElement;

    modal._quizAddedToCart = false;
    modal._postQuizShown = false;
    resetPostQuizInModal(modal);
    loadQuiz(modal);
    watchQuizRender(modal);

    modal.classList.remove('quiz-hub__modal--hidden');
    modal.setAttribute('aria-hidden', 'false');
    lockBodyScroll();

    var launcherPanel = trigger && trigger.closest
      ? trigger.closest('.quiz-launcher__panel')
      : null;
    if (
      launcherPanel &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      morphModalFromPanel(modal, launcherPanel);
    }

    var closeBtn = modal.querySelector('.quiz-hub__modal-close');
    if (closeBtn) {
      window.requestAnimationFrame(function () {
        closeBtn.focus();
      });
    }
  }

  function closeModal(modal) {
    if (!modal || modal.classList.contains('quiz-hub__modal--hidden')) return;

    var body = modal.querySelector('[data-quiz-body]');
    if (isQuizResultsPage(body)) {
      markQuizCompleted(modal);
    }

    resetPostQuizInModal(modal);
    modal.classList.remove('quiz-hub__modal--morphing');
    var dialog = modal.querySelector('.quiz-hub__modal-dialog');
    if (dialog) dialog.style.animation = '';
    modal.classList.add('quiz-hub__modal--hidden');
    modal.setAttribute('aria-hidden', 'true');
    modal._quizAddedToCart = false;
    modal._postQuizShown = false;
    unlockBodyScroll();

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
    lastFocused = null;
  }

  function getOpenModal() {
    return document.querySelector('.quiz-hub__modal:not(.quiz-hub__modal--hidden)');
  }

  function initModals() {
    if (!document.querySelector('[data-quiz-modal]')) return;

    installQuizCartOctaneSync();
    initPostQuizUpsellSections();
    initResultsPromos();
    initCompletedCards();

    window.addEventListener('resize', function () {
      var open = getOpenModal();
      if (open) updateScrollHint(open);
    });

    document.addEventListener('click', function (e) {
      var retakeBtn = e.target.closest('[data-quiz-retake]');
      if (retakeBtn) {
        e.preventDefault();
        var retakeModal = document.getElementById(retakeBtn.getAttribute('data-quiz-retake'));
        if (retakeModal) {
          resetQuiz(retakeModal);
          openModal(retakeModal, retakeBtn);
        }
        return;
      }

      var opener = e.target.closest('[data-quiz-open]');
      if (opener) {
        e.preventDefault();
        openModal(document.getElementById(opener.getAttribute('data-quiz-open')), opener);
        return;
      }

      if (e.target.closest('[data-quiz-back]')) {
        var backModal = e.target.closest('.quiz-hub__modal');
        var nativeBack = findNativeBack(backModal && backModal.querySelector('[data-quiz-body]'));
        if (nativeBack) nativeBack.click();
        return;
      }

      if (e.target.closest('[data-quiz-skip]')) {
        var skipModal = e.target.closest('.quiz-hub__modal');
        var nativeSkip = findNativeSkip(skipModal && skipModal.querySelector('[data-quiz-body]'));
        if (nativeSkip) nativeSkip.click();
        return;
      }

      if (e.target.closest('[data-quiz-post-upsell-dismiss]')) {
        var dismissModal = e.target.closest('[data-quiz-modal]');
        if (dismissModal) closeModal(dismissModal);
        return;
      }

      if (e.target.closest('[data-quiz-close]')) {
        requestCloseModal(e.target.closest('.quiz-hub__modal'));
      }
    });

    // Keyboard activation for card triggers (role="button").
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        requestCloseModal(getOpenModal());
        return;
      }

      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        var opener = e.target.closest('[data-quiz-open]');
        if (opener) {
          e.preventDefault();
          openModal(document.getElementById(opener.getAttribute('data-quiz-open')), opener);
        }
      }
    });
  }

  function init() {
    initReveal();
    initModals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
